import type { MouseEvent } from "react";

import CheckIcon from "@mui/icons-material/Check";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Tooltip } from "@mui/material";

import { useCopyToClipboard } from "hooks/useCopyToClipboard";

import { StyledCopyButton } from "./CopyIconButton.styled";

export interface CopyIconButtonProps {
    value: string;
    tooltipLabel?: string;
    copiedLabel?: string;
    stopPropagation?: boolean;
}

// Some legacy pages (e.g. the SourceModal overview tabs) still carry a
// global `.bearer-token-blockquote svg { color; opacity on hover }` rule.
// Inline styles beat any stylesheet selector regardless of nesting depth,
// so this keeps the icon's look consistent everywhere without touching
// that legacy CSS.
const ICON_STYLE = { color: "inherit", fontSize: 16, opacity: 1 };

const CopyIconButton = ({
    value,
    tooltipLabel = "Copy",
    copiedLabel = "Copied!",
    stopPropagation = false,
}: CopyIconButtonProps) => {
    const { copied, copy } = useCopyToClipboard();

    const handleClick = (e: MouseEvent) => {
        if (stopPropagation) e.stopPropagation();
        copy(value);
    };

    return (
        <Tooltip title={copied ? copiedLabel : tooltipLabel}>
            <StyledCopyButton $copied={copied} onClick={handleClick}>
                {copied ? (
                    <CheckIcon style={ICON_STYLE} />
                ) : (
                    <ContentCopyIcon style={ICON_STYLE} />
                )}
            </StyledCopyButton>
        </Tooltip>
    );
};

export default CopyIconButton;
